import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityAccessComparisonByObjectIdSlice } from './get';

export const coreDataSecurityAccessComparisonByObjectIdReducers = combineReducers({
	get: getCoreDataSecurityAccessComparisonByObjectIdSlice.asyncReducers
});

export const coreDataSecurityAccessComparisonByObjectIdWatchers = combineAllWatchers([
	getCoreDataSecurityAccessComparisonByObjectIdSlice.asyncWatchers
]);
